import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SdmPermissionDirective } from '../../directives/sdmpermission.directive';
import { ContentPipe } from '../../pipes/content.pipe';
import { OnEnterDirective } from '../../directives/on-enter.directive';
import { OnEscapeDirective } from '../../directives/on-escape.directive';


export const SHARED_IMPORTS = [
  CommonModule,
  FormsModule,
  ContentPipe,
  SdmPermissionDirective,
  OnEnterDirective,
  OnEscapeDirective
];